<sb-field-wrapper
  [control]="ngControl.control!"
  [errorsAlign]="errorsAlign"
  [hideRequiredIndicator]="hideRequiredIndicator"
  [hint]="hint"
  [humanize]="humanize"
  [instanceId]="instanceId"
  [label]="label"
  [labelTemplate]="labelTemplate"
  [preservedFeedbackSpace]="preservedFeedbackSpace"
>
  <div class="field" [ngClass]="fieldClass" [ngStyle]="fieldStyle">
    <div class="attachments">
      <ng-content />
    </div>

    <label class="textarea" (mousedown)="onFieldMouseDown($event)">
      <textarea
        #textareaRef
        class="textarea__input"
        [attr.id]="instanceId"
        [attr.placeholder]="placeholder || null"
        [attr.readonly]="readonly || null"
        [attr.rows]="rows || null"
        [disabled]="disabled"
        [(ngModel)]="value"
        (blur)="onBlur()"
        (ngModelChange)="onInputChange($event)"
      ></textarea>
      @if (autoexpand) {
        <span class="textarea__helper visually-hidden" [style.--field-max-rows]="validatedMaxRows">{{
          `${value} `
        }}</span>
      }
    </label>
    <div class="send-action">
      @if (allowVoiceMessage() && !value && !hasAnyContent()) {
        <button
          #voiceMessageButton
          sbButton
          [iconOnly]="true"
          [shadow]="'default-sm'"
          [variant]="'fill-light'"
          (click)="record.emit()"
        >
          <sb-icon [name]="'mic-on-fill'" [size]="'7'">
            <div class="bg-gradient-blue mix-blend-mode-screen fill-parent"></div>
          </sb-icon>
        </button>
      } @else {
        <button
          sbButton
          [disabled]="disabled || sendDisabled"
          [iconOnly]="true"
          [variant]="'fill-blue'"
          (mousedown)="onSendMouseDown($event)"
        >
          <sb-icon [name]="'send'" [size]="'7'" />
        </button>
      }
    </div>
  </div>
</sb-field-wrapper>
